import {useEffect} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'

function readMustChange(): boolean {
  try {
    const raw = localStorage.getItem('admin')
    if (!raw) return false
    return !!JSON.parse(raw).must_change_password
  } catch {
    return false
  }
}

export default function MustChangePasswordBanner() {
  const loc = useLocation()
  const navigate = useNavigate()
  const must = readMustChange()

  useEffect(() => {
    if (must && !loc.pathname.startsWith('/account/settings')) {
      navigate('/account/settings', {replace: true})
    }
  }, [must, loc.pathname, navigate])

  if (!must) return null
  if (loc.pathname.startsWith('/account/settings')) return null

  return (
    <div className='alert alert-warning d-flex align-items-center border-0 rounded-0 mb-0 mx-0 px-6 py-4'>
      <div className='flex-grow-1'>
        <strong>Password update required.</strong> Please change your password before continuing.
      </div>
      <Link to='/account/settings' className='btn btn-sm btn-warning'>
        Open account settings
      </Link>
    </div>
  )
}
